import { h, Host } from '@stencil/core';
export class PesSlideDownContainer {
  constructor() {
    this.active = undefined;
  }
  render() {
    return (h(Host, { class: { active: this.active } }, h("slot", null)));
  }
  static get is() { return "pes-slide-down-container"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-slide-down-container.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-slide-down-container.css"]
    };
  }
  static get properties() {
    return {
      "active": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "active",
        "reflect": false
      }
    };
  }
}
